import React from "react";
import { TopTrendingNakiNigunAlbumsTemplate } from "themes/administration/analytics/components";

function TopTrendingNakiNigunAlbums(props) {
    return <TopTrendingNakiNigunAlbumsTemplate {...props} />;
}

export default TopTrendingNakiNigunAlbums;
